export const logoIcon = (
  <svg width="129" height="74" viewBox="0 0 129 74" fill="none">
    <path
      d="M86.7092 24.723L97.5288 0.423431H91.6761L84.0143 17.6165V0.423431H78.1616V54.1388H84.0143V30.0199C89.3286 33.6068 91.3289 39.3217 91.8915 44.1007C92.5269 49.4757 92.5538 54.0794 92.5511 54.1253L92.5376 54.3114H98.218V54.1388C98.218 42.9841 96.7077 36.0314 92.5215 29.9848C90.4808 27.037 88.2598 25.4944 86.7038 24.7257L86.7092 24.723Z"
      fill="#1C1468"
    />
    <path
      d="M8.90123 0.423431H0.281006V54.1388H6.13371V30.0199H8.89853C14.7485 30.0199 17.6237 26.7943 17.6237 20.8745V9.57152C17.6237 3.649 14.7539 0.423431 8.90123 0.423431ZM11.771 21.2413C11.771 23.8843 10.7588 24.7311 8.89584 24.7311H6.12833V5.70947H8.89584C10.7588 5.70947 11.771 6.55632 11.771 9.19934V21.244V21.2413Z"
      fill="#1C1468"
    />
    <path
      d="M27.7192 0.423431H21.8665V54.1388H27.7192V0.423431Z"
      fill="#1C1468"
    />
    <path
      d="M44.4776 24.723H37.828V0.423431H31.9753V54.1361H37.828V30.0091H44.4776V54.1361H50.4353V0.423431H44.4776V24.723Z"
      fill="#1C1468"
    />
    <path
      d="M59.123 0.423431L53.1626 54.1388H58.9157L61.5001 30.0199H67.2425L69.9265 54.1388H75.6635L69.7004 0.423431H59.1203H59.123ZM62.0816 24.723L64.4211 6.05738L66.6664 24.723H62.079H62.0816Z"
      fill="#1C1468"
    />
    <path
      d="M107.309 0.423431H101.457V54.1388H107.309V0.423431Z"
      fill="#1C1468"
    />
    <path
      d="M117.561 8.93502C117.561 6.292 118.624 5.28603 120.487 5.28603C122.35 5.28603 123.411 6.2893 123.411 8.93502V15.877H128.943V9.3045C128.943 3.38467 126.017 0.00268555 120.326 0.00268555H120.331C114.637 0.00268555 111.711 3.38737 111.711 9.3072C111.711 19.8793 123.15 37.5956 123.15 45.2064C123.15 47.8494 121.979 48.8015 120.116 48.8015C118.253 48.8015 117.082 47.8521 117.082 45.2064V37.4581H111.55V44.8342C111.55 50.7541 114.53 54.1361 120.275 54.1361C126.02 54.1361 129 50.7541 129 44.8342C129 34.2622 117.561 16.5458 117.561 8.93502Z"
      fill="#1C1468"
    />
    <path
      d="M5.29645 73.6189C5.16454 73.2252 5.07839 72.9851 5.07839 71.7418V69.3388C5.07839 67.9202 4.59919 67.3943 3.50888 67.3943H2.6797V73.6189H0.281006V58.3326H3.89924C6.38408 58.3326 7.45286 59.4895 7.45286 61.8494V63.0495C7.45286 64.6219 6.95212 65.6494 5.88334 66.151C7.08134 66.6527 7.47439 67.8097 7.47439 69.4063V71.7661C7.47439 72.5078 7.49593 73.0553 7.73553 73.6216H5.29376L5.29645 73.6189ZM2.6797 60.5144V65.2098H3.61656C4.51035 65.2098 5.05416 64.816 5.05416 63.5943V62.0867C5.05416 60.9945 4.68265 60.5144 3.83193 60.5144H2.67701H2.6797Z"
      fill="#1C1468"
    />
    <path
      d="M11.4451 64.7729H14.7376V66.9574H11.4451V71.4344H15.5883V73.6189H9.04907V58.3326H15.5883V60.5171H11.4451V64.7756V64.7729Z"
      fill="#1C1468"
    />
    <path
      d="M20.1865 58.1572C22.5179 58.1572 23.7186 59.5543 23.7186 62.0004V62.4805H21.4518V61.8467C21.4518 60.7544 21.0157 60.3391 20.2538 60.3391C19.492 60.3391 19.0558 60.7544 19.0558 61.8467C19.0558 64.9913 23.7428 65.582 23.7428 69.9483C23.7428 72.3945 22.5233 73.7915 20.1677 73.7915C17.8121 73.7915 16.5925 72.3945 16.5925 69.9483V69.0098H18.8593V70.1021C18.8593 71.1943 19.3385 71.5881 20.1031 71.5881C20.8676 71.5881 21.3468 71.1943 21.3468 70.1021C21.3468 66.9574 16.6598 66.3668 16.6598 62.0004C16.6598 59.5543 17.8578 58.1572 20.1919 58.1572H20.1865Z"
      fill="#1C1468"
    />
    <path
      d="M24.459 58.3298H31.8704V60.5144H29.3641V73.6189H26.9654V60.5144H24.459V58.3298Z"
      fill="#1C1468"
    />
    <path
      d="M39.7852 73.6189H37.365L36.9504 70.8464H34.0079L33.5933 73.6189H31.3911L33.8329 58.3326H37.3434L39.7852 73.6189ZM34.3121 68.7698H36.6219L35.467 61.0376L34.3121 68.7698Z"
      fill="#1C1468"
    />
    <path
      d="M43.0132 58.3298V70.1236C43.0132 71.2159 43.4924 71.6097 44.257 71.6097C45.0215 71.6097 45.5007 71.2159 45.5007 70.1236V58.3298H47.7675V69.9699C47.7675 72.4161 46.548 73.8131 44.1923 73.8131C41.8367 73.8131 40.6172 72.4161 40.6172 69.9699V58.3298H43.0159H43.0132Z"
      fill="#1C1468"
    />
    <path
      d="M54.1964 73.6189C54.0644 73.2252 53.9783 72.9851 53.9783 71.7418V69.3388C53.9783 67.9202 53.4991 67.3943 52.4088 67.3943H51.5796V73.6189H49.1809V58.3326H52.7991C55.284 58.3326 56.3528 59.4895 56.3528 61.8494V63.0495C56.3528 64.6219 55.852 65.6494 54.7832 66.151C55.9812 66.6527 56.3743 67.8097 56.3743 69.4063V71.7661C56.3743 72.5078 56.3958 73.0553 56.6354 73.6216H54.1937L54.1964 73.6189ZM51.5796 60.5144V65.2098H52.5165C53.4103 65.2098 53.9541 64.816 53.9541 63.5943V62.0867C53.9541 60.9945 53.5826 60.5144 52.7318 60.5144H51.5769H51.5796Z"
      fill="#1C1468"
    />
    <path
      d="M65.8155 73.6189H63.3952L62.9806 70.8464H60.0381L59.6236 73.6189H57.4214L59.8632 58.3326H63.3737L65.8155 73.6189ZM60.3424 68.7698H62.6522L61.4973 61.0376L60.3424 68.7698Z"
      fill="#1C1468"
    />
    <path
      d="M68.9545 62.5452V73.6189H66.7954V58.3326H69.8025L72.2658 67.4833V58.3326H74.4034V73.6189H71.9401L68.9545 62.5452Z"
      fill="#1C1468"
    />
    <path
      d="M75.4292 58.3298H82.8406V60.5144H80.3343V73.6189H77.9356V60.5144H75.4292V58.3298Z"
      fill="#1C1468"
    />
    <path
      d="M90.866 65.1019H94.2231V69.951C94.2231 72.3972 93.0008 73.7942 90.6479 73.7942C88.295 73.7942 87.0728 72.3972 87.0728 69.951V62.0004C87.0728 59.5543 88.2923 58.1572 90.6479 58.1572C93.0035 58.1572 94.2231 59.5543 94.2231 62.0004V63.4864H91.9563V61.8494C91.9563 60.7571 91.4771 60.3418 90.7125 60.3418C89.9479 60.3418 89.4688 60.7571 89.4688 61.8494V70.1048C89.4688 71.197 89.9479 71.5908 90.7125 71.5908C91.4771 71.5908 91.9563 71.197 91.9563 70.1048V67.2864H90.866V65.1019Z"
      fill="#1C1468"
    />
    <path
      d="M100.784 73.6189C100.652 73.2252 100.566 72.9851 100.566 71.7418V69.3388C100.566 67.9202 100.086 67.3943 98.9962 67.3943H98.167V73.6189H95.7683V58.3326H99.3865C101.871 58.3326 102.94 59.4895 102.94 61.8494V63.0495C102.94 64.6219 102.439 65.6494 101.371 66.151C102.569 66.6527 102.962 67.8097 102.962 69.4063V71.7661C102.962 72.5078 102.983 73.0553 103.223 73.6216H100.781L100.784 73.6189ZM98.167 60.5144V65.2098H99.1039C99.9976 65.2098 100.541 64.816 100.541 63.5943V62.0867C100.541 60.9945 100.17 60.5144 99.3192 60.5144H98.1643H98.167Z"
      fill="#1C1468"
    />
    <path
      d="M104.337 62.0004C104.337 59.5543 105.624 58.1572 107.977 58.1572C110.33 58.1572 111.617 59.5543 111.617 62.0004V69.951C111.617 72.3972 110.33 73.7942 107.977 73.7942C105.624 73.7942 104.337 72.3972 104.337 69.951V62.0004ZM106.736 70.1021C106.736 71.1943 107.215 71.6097 107.98 71.6097C108.744 71.6097 109.224 71.1943 109.224 70.1021V61.8467C109.224 60.7544 108.744 60.3391 107.98 60.3391C107.215 60.3391 106.736 60.7544 106.736 61.8467V70.1021Z"
      fill="#1C1468"
    />
    <path
      d="M115.456 58.3298V70.1236C115.456 71.2159 115.935 71.6097 116.7 71.6097C117.464 71.6097 117.943 71.2159 117.943 70.1236V58.3298H120.21V69.9699C120.21 72.4161 118.988 73.8131 116.635 73.8131C114.282 73.8131 113.06 72.4161 113.06 69.9699V58.3298H115.459H115.456Z"
      fill="#1C1468"
    />
    <path
      d="M128.951 62.1083V64.096C128.951 66.5421 127.775 67.8744 125.376 67.8744H124.243V73.6189H121.844V58.3326H125.376C127.775 58.3326 128.951 59.6649 128.951 62.111V62.1083ZM124.243 60.5144V65.6899H125.376C126.138 65.6899 126.553 65.3419 126.553 64.2497V61.9573C126.553 60.865 126.138 60.5171 125.376 60.5171H124.243V60.5144Z"
      fill="#1C1468"
    />
  </svg>
)
